<template>
    <ul class="pagination" v-if="totalPages > 1">
        <li :class="{ disabled: !previousPage }">
            <a class="hand" @click="$emit('input', previousPage)" v-if="previousPage">
                &laquo;
            </a>
            <span v-else>&laquo;</span>
        </li>

        <li v-for="page in pageLinks" :class="{ active: page === currentPage }">
            <span v-if="typeof page == 'string'">{{ page }}</span>
            <a class="hand" @click="$emit('input', page)" v-else>{{ page}}</a>
        </li>

        <li :class="{ disabled: !nextPage }">
            <a class="hand" @click="$emit('input', nextPage)" v-if="nextPage">
                &raquo;
            </a>
            <span v-else>&raquo;</span>
        </li>
    </ul>
</template>

<script>
import PaginatorMixins from './PaginatorMixins';

export default {
    mixins: [PaginatorMixins],
    props: ['value'],
    computed: {
        currentPage() {
            return parseInt(this.value) || 1;
        },
    },
}
</script>
